import React from "react";
import { Link } from "react-router-dom";
import Trending from "./Pages/Trending";
import TechieTalks from "./Pages/TechieTalks";
import DeveloperZone from "./Pages/DeveloperZone";
import Gadgets from "./Pages/Gadgets";
import Udemycoupons from "./Pages/UdemyCoupons";
import ScrollToTop from "./ScrollToTop";
import HomeTrending from "./Pages/HomeTrending";
import HomeTrending2 from "./Pages/HomeTrending2";

export default function Home() {
  return (
    <div className="container">
      <ScrollToTop />
      <div className="row">
        <div className="col-md-8">
          <HomeTrending />
        </div>
        <div className="col-md-4">
          <HomeTrending2 />
        </div>
      </div>

      <Trending />
      <TechieTalks />
      <DeveloperZone />
      <Gadgets />
      <Udemycoupons />
    </div>
  );
}
